import React from 'react';
import './App.scss';
import {AppRouter} from "./router";
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from "react-toastify";

function App() {
    return <>
        <AppRouter/>
        <ToastContainer/>
    </>;
}

export default App;
